import { useRef } from "react";

import {
  Typography,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons components
import CloseIcon from "@material-ui/icons/Close";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import {
  columnDateField,
  columnNumberField,
  sortableField,
  columnPriceField,
  columnPhoneField,
  columnEmailField,
} from "utils/tables-utils";

const columnModel = [
  sortableField({
    dataField: "IdPedido",
    text: "Pedido",
    align: "center",
  }),
  columnDateField(
    {
      dataField: "Data",
      text: "Data",
    },
    true
  ),
  columnNumberField(
    {
      dataField: "Quantidade",
      text: "Quantidade",
    },
    true
  ),
  columnPriceField(
    {
      dataField: "Valor",
      text: "Valor",
    },
    true
  ),
  sortableField({
    dataField: "NomeCliente",
    text: "Cliente",
  }),
  columnPhoneField({
    dataField: "TelefoneCliente",
    text: "Telefone",
  }),
  columnEmailField({
    dataField: "EmailCliente",
    text: "E-mail",
  }),
];

const useStyles = makeStyles((theme) => ({
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

export default function DialogDashboardOmni({ data, handleClose, title }) {
  const classes = useStyles();
  const contentRef = useRef(null);

  return data ? (
    <Dialog open={Boolean(data)} onClose={handleClose} maxWidth="lg">
      <DialogTitle disableTypography id="alert-dialog-title">
        <Typography variant="h2" component="h2">
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>
      <DialogContent ref={contentRef} style={{ padding: "0 1.5rem 1.5rem" }}>
        <Grid container>
          <Grid item xs={12}>
            <ToolkitTable
              searched={Boolean(data)}
              keyField="IdPedido"
              dataTable={data}
              columnModel={columnModel}
              pagination={{
                options: [10, 25, 50, 100],
                defaultOption: 10,
              }}
              showPrint
              notFoundTitle="Sua pesquisa não encontrou nenhum pedido correspondente."
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  ) : null;
}
